import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './Cursor.css';

const Cursor = () => {
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        const mouseMove = (e) => {
            setMousePosition({
                x: e.clientX,
                y: e.clientY
            });

            // Check if hovering over clickable element
            const target = e.target;
            const isClickable = target.tagName === 'BUTTON' ||
                target.tagName === 'A' ||
                target.closest('a') ||
                target.closest('button') ||
                target.classList.contains('service-card') ||
                target.classList.contains('nav-link');

            setIsHovered(!!isClickable);
        };

        window.addEventListener("mousemove", mouseMove);

        return () => {
            window.removeEventListener("mousemove", mouseMove);
        };
    }, []);

    const variants = {
        default: {
            x: mousePosition.x - 16,
            y: mousePosition.y - 16,
        },
        hover: {
            x: mousePosition.x - 30, // Adjust for larger size (60px / 2)
            y: mousePosition.y - 30,
        }
    };

    const dotVariants = {
        default: {
            x: mousePosition.x - 4,
            y: mousePosition.y - 4,
        }
    };

    return (
        <>
            <motion.div
                className={`custom-cursor ${isHovered ? 'hovered' : ''}`}
                variants={variants}
                animate={isHovered ? "hover" : "default"}
                transition={{ type: "spring", stiffness: 500, damping: 28, mass: 0.5 }}
            />
            <motion.div
                className="cursor-dot"
                variants={dotVariants}
                animate="default"
                transition={{ type: "tween", ease: "linear", duration: 0 }}
            />
        </>
    );
};

export default Cursor;
